
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import NR, {
  CodeForm,
  LoginFrom,
  Info,
  Login,
  InfoForm
} from "@/lib/model/NRXQ/NRXQ";

@Component({
  components: {}
})
export default class NRInfo extends Vue {
  @Prop({ default: "", type: String }) connectCode!: string;
  @Prop({ default: "", type: String }) token!: string;
  @Prop({ default: true, type: Boolean }) isPc!: boolean;

  formData = new InfoForm();
  rules = {
    name: [{ required: true, message: "请输入姓名", trigger: "change" }],
    companyName: [
      { required: true, message: "请输入公司名称", trigger: "change" }
    ]
  };

  submit() {
    (this.$refs["form"] as any)?.validate((valid: any) => {
      if (valid) {
        this.formData.connectCode = this.connectCode;
        let storageToken = "";
        try {
          storageToken = String(localStorage.getItem("nrxqToken"));
        } catch (e) {
          console.log(e);
        }
        this.formData.nrxqToken = storageToken || this.token;

        Info.set(this.formData).then(info => {
          if (info.nrxqLoginStatus === "needLogin") {
            //去登陆
            this.$emit("toNRLogin");
          }
          if (info.nrxqLoginStatus === "needContent") {
            //填写信息
            this.$emit("toNRInfo", this.formData.nrxqToken);
          }
          if (info.nrxqLoginStatus === "noNeed") {
            //直接查看
            this.$emit("ok", this.formData.nrxqToken);
          }
        });
      }
    });
  }
}
